import { Grid2 as Grid } from "@mui/material";
import moment from "moment";

import { Product } from "api/memberPortal/project/product/product.types";
import LabelText from "components/UI/Text/LabelText";

import { ProficiencyFeedbackFormValues } from "../../../ProficiencyFeedbackForm.schema";

interface ProductInfoSectionProps {
  feedbackForm: ProficiencyFeedbackFormValues | undefined;
  product: Product;
}

const ProductInfoSection = ({
  feedbackForm,
  product,
}: ProductInfoSectionProps) => {
  const displayDate = feedbackForm?.edited_on
    ? moment.utc(feedbackForm.edited_on).format("MM/DD/YYYY")
    : moment().format("MM/DD/YYYY");

  const displayYear = feedbackForm?.edited_on
    ? moment.utc(feedbackForm.edited_on).format("YYYY")
    : moment().format("YYYY");

  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={6}>
        <LabelText label="DATE">{displayDate}</LabelText>
      </Grid>

      <Grid size={6}>
        <LabelText label="Product Name">{product?.product_name}</LabelText>
      </Grid>

      <Grid size={6}>
        <LabelText label="CCTL">{product?.assigned_lab.name}</LabelText>
      </Grid>

      <Grid size={6}>
        <LabelText label="VID">{product?.v_id}</LabelText>
      </Grid>

      <Grid size={12}>
        <LabelText label="NIAP Record ID">{`CCEVS-PFR-VID${product?.v_id}-${displayYear}`}</LabelText>
      </Grid>
    </Grid>
  );
};

export default ProductInfoSection;
